const APIM_ENQUEUE_URL = "https://utv-api.cappelendamm.no/enqueue";
const SERVICEBUS_QUEUES = {
    EMAIL_OUTBOUND: {
        URL: APIM_ENQUEUE_URL,
        HEADERS: [
            {
                name: "Authorization",
                value: `Bearer ${process.env.APIM_NETTHANDEL_AUTH_KEY_UTV}`,
            },
            {
                name: "X-Queue-Name",
                value: "emails",
            },
        ],
    },
    ORDERS: {
        URL: APIM_ENQUEUE_URL,
        HEADERS: [
            {
                name: "Authorization",
                value: `Bearer ${process.env.APIM_NETTHANDEL_AUTH_KEY_UTV}`,
            },
            {
                name: "X-Queue-Name",
                value: "orders",
            },
        ],
    },
    INDEX: {
        URL: APIM_ENQUEUE_URL,
        HEADERS: [
            {
                name: "Authorization",
                value: `Bearer ${process.env.APIM_NETTHANDEL_AUTH_KEY_UTV}`,
            },
            {
                name: "X-Queue-Name",
                value: "indexing",
            },
        ],
    },
    SUBSCRIPTIONS: {
        URL: APIM_ENQUEUE_URL,
        HEADERS: [
            {
                name: "Authorization",
                value: `Bearer ${process.env.APIM_NETTHANDEL_AUTH_KEY_UTV}`,
            },
            {
                name: "X-Queue-Name",
                value: "subscriptions",
            },
        ],
    },
    PAYMENTS: {
        URL: APIM_ENQUEUE_URL,
        HEADERS: [
            {
                name: "Authorization",
                value: `Bearer ${process.env.APIM_NETTHANDEL_AUTH_KEY_UTV}`,
            },
            {
                name: "X-Queue-Name",
                value: "payments",
            },
        ],
    },
    PRODUCTS: {
        URL: APIM_ENQUEUE_URL,
        HEADERS: [
            {
                name: "Authorization",
                value: `Bearer ${process.env.APIM_NETTHANDEL_AUTH_KEY_UTV}`,
            },
            {
                name: "X-Queue-Name",
                value: "products",
            },
        ],
    },
    CUSTOMER: {
        URL: APIM_ENQUEUE_URL,
        HEADERS: [
            {
                name: "Authorization",
                value: `Bearer ${process.env.APIM_NETTHANDEL_AUTH_KEY_UTV}`,
            },
            {
                name: "X-Queue-Name",
                value: "customers",
            },
        ],
    },
};
export const WEBHOOK_URL_UTV_ROUTING = [
    {
        name: "onOrderCreate (sendgrid-service-bus)",
        url: SERVICEBUS_QUEUES.EMAIL_OUTBOUND.URL,
        headers: [
            ...SERVICEBUS_QUEUES.EMAIL_OUTBOUND.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "order.created",
            },
        ],
    },
    {
        name: "onOrderCreate (servicebus -> florida)",
        url: SERVICEBUS_QUEUES.ORDERS.URL,
        headers: [
            ...SERVICEBUS_QUEUES.ORDERS.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "order.created",
            },
        ],
    },
    {
        name: "onOrderCreate (service-bus - > meilisearch)",
        url: SERVICEBUS_QUEUES.INDEX.URL,
        headers: [
            ...SERVICEBUS_QUEUES.INDEX.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "orders.create",
            },
        ],
    },
    {
        name: "onOrderUpdate (service-bus - > meilisearch)",
        url: SERVICEBUS_QUEUES.INDEX.URL,
        headers: [
            ...SERVICEBUS_QUEUES.INDEX.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "orders.update",
            },
        ],
    },
    {
        name: "onOrderPipelineStageChanged (service-bus - > meilisearch)",
        url: SERVICEBUS_QUEUES.INDEX.URL,
        headers: [
            ...SERVICEBUS_QUEUES.INDEX.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "orders.pipeline-stage-change",
            },
        ],
    },
    {
        name: "onFloridaPipelineChangedToCanceled (servicebus -> paymentService)",
        url: SERVICEBUS_QUEUES.PAYMENTS.URL,
        headers: [
            ...SERVICEBUS_QUEUES.PAYMENTS.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "nets.payment.cancel",
            },
        ],
    },
    {
        name: "onOrderDelete (service-bus - > meilisearch)",
        url: SERVICEBUS_QUEUES.INDEX.URL,
        headers: [
            ...SERVICEBUS_QUEUES.INDEX.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "orders.delete",
            },
        ],
    },
    {
        name: "onInvoiceReminder (servicebus -> sendgrid)",
        url: SERVICEBUS_QUEUES.EMAIL_OUTBOUND.URL,
        headers: [
            ...SERVICEBUS_QUEUES.EMAIL_OUTBOUND.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "invoice.reminder",
            },
        ],
    },
    {
        name: "onCustomerCreate (service-bus -> meilisearch)",
        url: SERVICEBUS_QUEUES.INDEX.URL,
        headers: [
            ...SERVICEBUS_QUEUES.INDEX.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "customers.create",
            },
        ],
    },
    {
        name: "onCustomerDelete (service-bus -> meilisearch)",
        url: SERVICEBUS_QUEUES.INDEX.URL,
        headers: [
            ...SERVICEBUS_QUEUES.INDEX.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "customers.delete",
            },
        ],
    },
    {
        name: "onCustomerUpdate (service-bus -> meilisearch)",
        url: SERVICEBUS_QUEUES.INDEX.URL,
        headers: [
            ...SERVICEBUS_QUEUES.INDEX.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "customers.update",
            },
        ],
    },
    {
        name: "onCustomerUpdate (servicebus -> florida)",
        url: SERVICEBUS_QUEUES.CUSTOMER.URL,
        headers: [
            ...SERVICEBUS_QUEUES.CUSTOMER.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "update.florida",
            },
        ],
    },
    {
        name: "onSubscriptionContractsCancel (service-bus -> meilisearch)",
        url: SERVICEBUS_QUEUES.INDEX.URL,
        headers: [
            ...SERVICEBUS_QUEUES.INDEX.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "subscription-contracts.cancel",
            },
        ],
    },
    {
        name: "onSubscriptionContractsCreate (service-bus -> meilisearch)",
        url: SERVICEBUS_QUEUES.INDEX.URL,
        headers: [
            ...SERVICEBUS_QUEUES.INDEX.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "subscription-contracts.create",
            },
        ],
    },
    {
        name: "onSubscriptionContractsDelete (service-bus -> meilisearch)",
        url: SERVICEBUS_QUEUES.INDEX.URL,
        headers: [
            ...SERVICEBUS_QUEUES.INDEX.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "subscription-contracts.delete",
            },
        ],
    },
    {
        name: "onSubscriptionContractsUpdate (service-bus -> meilisearch)",
        url: SERVICEBUS_QUEUES.INDEX.URL,
        headers: [
            ...SERVICEBUS_QUEUES.INDEX.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "subscription-contracts.update",
            },
        ],
    },
    {
        name: "onSubscriptionContractsRenew (service-bus -> meilisearch)",
        url: SERVICEBUS_QUEUES.INDEX.URL,
        headers: [
            ...SERVICEBUS_QUEUES.INDEX.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "subscription-contracts.renew",
            },
        ],
    },
    {
        name: "onProductPublished",
        url: SERVICEBUS_QUEUES.PRODUCTS.URL,
        headers: [
            ...SERVICEBUS_QUEUES.PRODUCTS.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "product.published",
            },
        ],
    },
    {
        name: "onDispatchUpdated - (service-bus -> subscriptionService)",
        url: SERVICEBUS_QUEUES.SUBSCRIPTIONS.URL,
        headers: [
            ...SERVICEBUS_QUEUES.SUBSCRIPTIONS.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "dispatch.updated",
            },
        ],
    },
    {
        name: "onRenew - (servicebus -> subscriptionService)",
        url: SERVICEBUS_QUEUES.SUBSCRIPTIONS.URL,
        headers: [
            ...SERVICEBUS_QUEUES.SUBSCRIPTIONS.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "contract.renew",
            },
        ],
    },
    {
        name: "onOrderCreate (subscription service, track usage)",
        url: SERVICEBUS_QUEUES.SUBSCRIPTIONS.URL,
        headers: [
            ...SERVICEBUS_QUEUES.SUBSCRIPTIONS.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "contract.trackUsage",
            },
        ],
    },
    {
        name: "Nets stage when order finished",
        url: SERVICEBUS_QUEUES.PAYMENTS.URL,
        headers: [
            ...SERVICEBUS_QUEUES.PAYMENTS.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "nets.payment.stage.or.capture",
            },
        ],
    },
    {
        name: "onOrderShipped (service-bus -> sendgrid)",
        url: SERVICEBUS_QUEUES.EMAIL_OUTBOUND.URL,
        headers: [
            ...SERVICEBUS_QUEUES.EMAIL_OUTBOUND.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "order.shipped",
            },
        ],
    },
    {
        name: "On digital subscription contract created",
        url: SERVICEBUS_QUEUES.SUBSCRIPTIONS.URL,
        headers: [
            ...SERVICEBUS_QUEUES.SUBSCRIPTIONS.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "digitalSubscription.contract.created",
            },
        ],
    },
    {
        name: "On digital subscription contract deactivated",
        url: SERVICEBUS_QUEUES.SUBSCRIPTIONS.URL,
        headers: [
            ...SERVICEBUS_QUEUES.SUBSCRIPTIONS.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "digitalSubscription.contract.deactivated",
            },
        ],
    },
    {
        name: "On digital subscription order created",
        url: SERVICEBUS_QUEUES.SUBSCRIPTIONS.URL,
        headers: [
            ...SERVICEBUS_QUEUES.SUBSCRIPTIONS.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "digitalSubscription.order.created",
            },
        ],
    },
    {
        name: "On digital subscription customer created",
        url: SERVICEBUS_QUEUES.SUBSCRIPTIONS.URL,
        headers: [
            ...SERVICEBUS_QUEUES.SUBSCRIPTIONS.HEADERS,
            {
                name: "X-Queue-Subject",
                value: "digitalSubscription.customer.created",
            },
        ],
    },
    /**
     * Node
     *
     * Updated automagically when building the app
     */
    {
        name: "onSubscriptionCreated (qstash -> node -> sendgrid)",
        url: "nothing",
    },
    {
        name: "onSubscriptionCancelled (qstash -> node -> sendgrid)",
        url: "nothing",
    },
    {
        name: "Node | OnPublishItem (PIM)",
        url: "nothing",
    },
    {
        name: "onRemoveProduct - Unpublish (Node)",
        url: "nothing",
    },
    {
        name: "onTenantSyncFinished - (Node)",
        url: "nothing",
    },
    {
        name: "Node | OnTopicDelete",
        url: "nothing",
    },
    {
        name: "Node | OnTopicCreate",
        url: "nothing",
    },
    {
        name: "Node | OnTopicUpdate",
        url: "nothing",
    },
    {
        name: "onPriceListSync - Create - (Node)",
        url: "nothing",
    },
    {
        name: "onPriceListSync - Update - (Node)",
        url: "nothing",
    },
    {
        name: "onPriceListDelete - (Node)",
        url: "nothing",
    },
    // dynamics
    { name: "onCustomerCreate (dynamics)", url: "nothing" },
    { name: "onCustomerUpdate (dynamics)", url: "nothing" },
    { name: "onCustomerDelete (dynamics)", url: "nothing" },
    { name: "onOrderCreate (dynamics)", url: "nothing" },
    { name: "onOrderDelete (dynamics)", url: "nothing" },
    { name: "onOrderUpdate (dynamics)", url: "nothing" },
    { name: "onSubscriptionDelete (dynamics)", url: "nothing" },
    { name: "onSubscriptionCreate (dynamics)", url: "nothing" },
    { name: "onSubscriptionUpdate (dynamics)", url: "nothing" },
    { name: "onOrderPipelineUpdate (dynamics)", url: "nothing" },
    { name: "onSubscriptionRenew (dynamics)", url: "nothing" },
    { name: "onSubscriptionCancel (dynamics)", url: "nothing" },
    { name: "onProductPublish (dynamics)", url: "nothing" },
    { name: "onProductDelete (dynamics)", url: "nothing" },
];
